import { useMutation } from "@tanstack/react-query";
import { useShop } from "src/hooks/Utils/Shop/useShop";
import { queryClient } from "src/utils/init/queryClient";;
import { OpenapiSingleton } from "src/utils/OpenapiSingleton";

export const NOTIFICATION_TYPE = {
    ITEM_SOLD: "ITEM_SOLD",
    ITEM_FAVORITE: "ITEM_FAVORITE",
    ITEM_PAUSED: "ITEM_PAUSED",
    ICON_NOTIFICATION: "ICON_NOTIFICATION"

} as any

export type notificationType =
  (typeof NOTIFICATION_TYPE)[keyof typeof NOTIFICATION_TYPE];


interface notificationViewedMutationParams {
  notificationType?: notificationType;
   productId?: number
}

export default function useNotificationViewedMutation(notificationType?: notificationType, productId?: number) {
  
  const { shopMarketId } = useShop();

  const notificationViewedMutation = async ( params:notificationViewedMutationParams ) => {

    const { notificationType, productId } = params;
  
    return await OpenapiSingleton.CustomerAPIV2Api.notificationViewed(
        notificationType,
        shopMarketId,
        productId
    );
  }

  return useMutation({
      mutationFn: notificationViewedMutation,
      onMutate: async () => {
        await queryClient.cancelQueries({ queryKey: ['customerNotification'] })
        await queryClient.setQueryData(['customerNotification'], 
        {   itemFavourite: false,
            itemPaused: false,
            itemSold: false,
            iconNotification: false
        });
      },
      onError: () => {
        queryClient.invalidateQueries({ queryKey: ['customerNotification'] })
      }
    },
  );
}
